import React from 'react';

import { CompanyInformationFormWrapperVerifierAdmin } from 'src/components/account';
import { CompanyInformationFormEmployerAdmin } from 'src/components/account/CompanyInformationFormEmployerAdmin';
import { CompanyInformationFormPeoAdmin } from 'src/components/account/CompanyInformationFormPeoAdmin';
import { CompanyInformationFormPeoPayrollProvider } from 'src/components/account/CompanyInformationFormPeoPayrollProvider';
import { DetailPageLayout } from 'src/components/common';
import { useScreenInfo } from 'src/hooks/common';
import { useCurrentUserPermissions } from 'src/hooks/user';
import {
  UndergoReverificationConfirmationModal,
  VerifierCredentialStatusNoticeModal,
} from 'src/modals/verifier';
import { NotFoundErrorPage } from 'src/pages/not-found';

export const CompanyInformationPage: React.FC = () => {
  const {
    isVerifierAdmin,
    isEmployerAdmin,
    isPeoSuperAdmin,
    isPeoAdmin,
    isPeoPayrollProviderUser,
  } = useCurrentUserPermissions();
  const { isMobile } = useScreenInfo();

  const companyInformationElement = React.useMemo(() => {
    if (isPeoSuperAdmin || isPeoAdmin) {
      return <CompanyInformationFormPeoAdmin />;
    }
    if (isVerifierAdmin) {
      return <CompanyInformationFormWrapperVerifierAdmin />;
    }
    if (isEmployerAdmin) {
      return <CompanyInformationFormEmployerAdmin />;
    }
    if (isPeoPayrollProviderUser) {
      return <CompanyInformationFormPeoPayrollProvider />;
    }

    return <NotFoundErrorPage />;
  }, [isPeoSuperAdmin, isPeoAdmin, isVerifierAdmin, isEmployerAdmin, isPeoPayrollProviderUser]);

  if (isMobile) {
    return companyInformationElement;
  }

  return (
    <DetailPageLayout titleContent="Company Information">
      {companyInformationElement}
      <UndergoReverificationConfirmationModal />
      <VerifierCredentialStatusNoticeModal />
    </DetailPageLayout>
  );
};
